import React from 'react';
import PropTypes from 'prop-types';
import { useField } from 'formik';
import { CustomInput } from 'reactstrap';
import { split, join, includes, concat } from 'lodash';

const CheckboxGroup = ({ name, inline, options, readOnly, ...props }) => {
  const [field, meta, helper] = useField(name);

  return (
    <>
      {options?.map((o, i) => (
        <CustomInput
          key={`${name}_${i}`}
          id={`${name}_${i}`}
          type='checkbox'
          name={name}
          value={o.value}
          label={o.label}
          onChange={() => {
            let fieldValue = field.value;
            let values = fieldValue ? split(fieldValue, '|') : [];
            if (includes(values, o.value)) {
              values = values.filter((e) => e !== o.value);
            } else {
              values = concat(values, [o.value]);
            }
            fieldValue = join(values, '|');
            helper.setValue(fieldValue, true);
          }}
          checked={meta?.value?.includes(o.value)}
          disabled={readOnly}
          inline={inline}
          invalid={meta.error && meta.touched}
          {...props}
        />
      ))}
    </>
  );
};
CheckboxGroup.propTypes = {
  name: PropTypes.string.isRequired,
  options: PropTypes.array,
  readOnly: PropTypes.bool,
  inline: PropTypes.bool,
};

export default CheckboxGroup;
